import { useInterval } from '@app/customer/Composables/useInterval';

/**
 * Each UPDATE_HEIGHT_INTERVAL milliseconds, check if the height of the app has changed.
 * If it has, call the callback function with the new height.
 */
const UPDATE_HEIGHT_INTERVAL = 50;

export function useOnAppResize(callback: (height: number) => void): void {
  const $app = document.getElementById('app');

  if ($app === null) {
    return;
  }

  $app.style.height = 'auto';
  document.querySelector('html')!.style.overflow = 'hidden';

  let currentScrollHeight = 0;

  useInterval(() => {
    const newScrollHeight = $app.scrollHeight;

    if (newScrollHeight !== currentScrollHeight) {
      currentScrollHeight = newScrollHeight;
      callback(newScrollHeight);
    }
  }, UPDATE_HEIGHT_INTERVAL);
}
